<div class="container-fluid">
  <div class="d-flex align-items-center gap-2">
    <app-searchable-select
      class="col-md-3 mt-3"
      [options]="counsellors$ | async"
      [multiple]="true"
      [hideSelectAllOption]="false"
      [(selectedValue)]="submittedBy"
      [displayKey]="'userName'"
      [valueKey]="'userName'"
      [label]="'Submitted By'"
      [placeholder]="'All Counsellors'"
    ></app-searchable-select>

    <mat-form-field appearance="outline" class="col-md-3 mt-3">
      <mat-label>Enter a date range</mat-label>

      <mat-date-range-input [rangePicker]="picker" [max]="today">
        <input matStartDate [(ngModel)]="start" placeholder="Start date">
        <input matEndDate [(ngModel)]="end" placeholder="End date">
      </mat-date-range-input>

      <mat-hint>DD/MM/YYYY – DD/MM/YYYY</mat-hint>

      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>

    <div class="d-flex gap-2">
      <button mat-mini-fab color="accent" (click)="onSearch()" matTooltip="Search">
        <mat-icon>search</mat-icon>
      </button>
      <button mat-mini-fab color="accent" (click)="onClear()" matTooltip="Clear Filters">
        <mat-icon>clear</mat-icon>
      </button>
    </div>
  </div>


  <div class="ngxTableHeader">
    <ul class="header-buttons-left ms-0 mb-0">
      <li class="dropdown">
        <h2>Counselling Induction List</h2>
      </li>
      <li class="dropdown m-l-20">
        <label for="search-input"><i class="material-icons search-icon">search</i></label>
        <input placeholder="Search" type="text" class="browser-default search-field"
               (keyup)='applyFilter($event)' aria-label="Search box" #input>
      </li>
    </ul>
    <ul class="header-buttons mr-2">
      <li>
        <button mat-mini-fab color="primary" (click)="AddInductions()"
                permission="Counselling Induction"
                [permissionTypes]="[PermissionType.ALL, PermissionType.ADD]">
          <mat-icon class="col-white">add</mat-icon>
        </button>
      </li>
    </ul>
  </div>
  <div class="responsive_table">
    <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z2 w-100">
      <ng-container matColumnDef="sr">
        <th mat-header-cell *matHeaderCellDef>Sr. No</th>
        <td mat-cell *matCellDef="let i=index;">{{i+1}}</td>
      </ng-container>
      <ng-container matColumnDef="inductionFor">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Induction For</th>
        <td mat-cell *matCellDef="let row">{{row.inductionFor}}</td>
      </ng-container>
      <ng-container matColumnDef="submittedBy">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Submitted By</th>
        <td mat-cell *matCellDef="let row">{{row.submittedBy}}</td>
      </ng-container>
      <ng-container matColumnDef="createdAt">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Created At</th>
        <td mat-cell *matCellDef="let row">{{row.createdAt.toDate() | date:'dd-MM-yyyy'}}</td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let row">
          <button mat-icon-button (click)="viewInduction(row.id)" color="primary"
                  permission="Counselling Induction" [permissionTypes]="[PermissionType.ALL, PermissionType.VIEW]">
            <mat-icon>visibility</mat-icon>
          </button>
          <button mat-icon-button (click)="EditInduction(row.id)" color="primary"
                  permission="Counselling Induction" [permissionTypes]="[PermissionType.ALL, PermissionType.EDIT]">
            <mat-icon>edit</mat-icon>
          </button>
          <button mat-icon-button (click)="DeleteInduction(row.id)" color="warn"
                  permission="Counselling Induction" [permissionTypes]="[PermissionType.ALL, PermissionType.ARCHIVE]">
            <mat-icon>delete</mat-icon>
          </button>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
  <mat-paginator [pageSizeOptions]="[10, 20, 50, 100]" showFirstLastButtons></mat-paginator>
</div>
